export class StorageKeyConstants {
    static apiTokenName = 'cc-token';
    static apiLoginTokenName = 'cc-login-token';
    static userInfo = 'user-info'; // display user info
    static loggedInUserInfo = 'logged-in-user-info';
    static apiIsShadowLogin = 'cc-is-shadow-login';

    static userThemeKey = 'cc_devex_theme_color';
    static userTimeZoneKey = 'cc_time_zone_name';
    static userPrecisionKey = 'cc_precision';

    static clientFormsAuthenticationCookieName = 'CCCFAC';

    static wfEditorFormPanelWidthInPercent = 'cc_wf_editor_panel_width';
    static wfInvoicePanelWidthInPercent = 'cc_wf_invoice_panel_width';
    static wfInvoiceViewerPosition = 'cc_wf_invoice_viewer_position';
    static wfPaymentRequestPosition = 'cc_wf_payment_request_position';

    static userOpenLinksKey = 'cc_open_links';
    static userDashboardsKey = 'cc_user_dashboards';
    static userCBDashboardsKey = 'cc_user_cb_dashboards';
    static userCCBDashboardsKey = 'cc_user_ccb_dashboards';
    static userCommunityDashboardsKey = 'cc_user_community_dashboards';
    static userPropertyDashboardsKey = 'cc_user_property_dashboards';
    static userScrollbarKey = 'cc_user_scrollbar_mode';
    static userScrollTypeKey = 'cc_user_scrollbar_type';
    static userTopMenuKey = 'cc_user_topmenu_mode';
    static communityPropertyDashboardsKey = 'cc_community_property_dashboards';
    static userDownloadsKey = 'cc_download_files';
    static ciramailNotesKey = 'cc_ciramail_notes';
    static userAnnouncementsCountKey = 'cc_user_announcements_count';
    static userShowAnnouncementsKey = 'cc_user_show_announcements';

    static chartPaletteKey = 'cc_chart_palette_name';
    static chartPaletteExtentionKey = 'cc_chart_palette_extention_mode_name';

    static onetimePaymentResultLogKey = 'one_time_payment_result_log_key';

    static bookmarks = 'cc_bookmarks';

    static cmEmailViewerPanelWidthInPercent = 'cc_email_viewer_panel_width';
    static cmReadingPanePanelWidthInPercent = 'cc_email_reading_pane_panel_width';
    static cmReadingPanePosition = 'cc_email_reading_pane_position';

    static ciraHelpSidebarSizes = 'cc_cirahelp_sidebar_sizes';
    static communityPropertiesLayout = 'cc_community_properties_layout';
    static communityPropertiesLayoutSizes = 'cc_community_properties_layout_sizes';
    static emailSentKey = 'cc_email_sent_status_key';
    static emailReadKey = 'cc_email_read_status';

    static emailWindowSize = 'cc_email_window_size';

    static violationInspectionEditorPanelWidthInPercent = 'cc_vr_inspection_editor_panel_width';
    static violationInspectionHistoryPanelWidthInPercent = 'cc_vr_inspection_history_panel_width';
    static inspectionScheduleDetailPanelWidthInPercent = 'cc_inspection_schedule_details_panel_width';
    static inspectorFollowUpsPropertyDetailsPanelWidthInPercent =
        'cc_inspector_follow_ups_property_details_panel_width';
    static violationInspectionApprovalHearingDate = 'cc_vr_inspection_approval_hearing_date';
    static violationInspectionApprovalHearingTime = 'cc_vr_inspection_approval_hearing_time';
    static violationInspectionApprovalHearingLocation = 'cc_vr_inspection_approval_hearing_location';
    static communityAmenitiesGridPanelWidthInPercent = 'cc_community_Amenities_panel_width';
    static communityAmenitiesDetailsPanelWidthInPercent = 'cc_community_Amenities_details_panel_width';

    static workQueueBillFormPanelWidthInPercent = 'ccb_work_queue_bill_form_panel_width';
    static workQueueInvoiceViewPanelWidthInPercent = 'ccb_work_queue_invoice_view_panel_width';
    static workQueueInvoiceViewPosition = 'ccb_work_queue_invoice_view_position';

    static arCollectionLayout = 'cc_ar_collection_layout';
    static arCollectionLayoutSizes = 'cc_ar_collection_layout_sizes';
    static arCollectionDashbordKey = 'cc_ar_collection_dashboards';

    static ptSgProcessYear = 'cc_pt_sg_process_year';
    static ptCoProcessYear = 'cc_pt_co_process_year';
    static ptFrpProcessYear = 'cc_pt_frp_process_year';
    static ptMmrProcessYear = 'cc_mmr_frp_process_year';
    static ptStProcessYear = 'cc_pt_st_process_year';
    static ptFtProcessYear = 'cc_pt_ft_process_year';

    static architecturalApplicationFilter = 'cc_acc_queue';

    static myTextViewerPanelWidthInPercent = 'cc_my_text_viewer_panel_width';
    static myTextReadingPanePanelWidthInPercent = 'cc_my_text_reading_pane_panel_width';
    static myTextReadingPanePosition = 'cc_my_text_reading_pane_position';

    static paymentPostErrorLayoutSizes = 'cc_payment_post_error_layout_sizes';

    static responseTemplateLayout = 'cc_response_template_layout';
    static reportTemplateLayout = 'cc_report_template_layout';
    static batchJobEmailLayout = 'cc_batch_job_email_layout';

    static workAreaPanelWidthInPercent = 'cc_work_area_panel_width';
    static workAreaLocationPanelWidthInPercent = 'cc_work_area_location_panel_width';

    static helpConfigurationListPanelWidth = 'cc_help_config_list_panel_width';
    static helpConfigurationContentPanelWidth = 'cc_help_config_content_panel_width';

    static testPlanUserPanelWidth = 'cc_test_plan_user_panel_width';
    static testPlanAssignmentPanelWidth = 'cc_test_plan_assignment_panel_width';

    static testingGridPanelWidth = 'cc_testing_grid_panel_width';
    static testingQuestionPanelWidth = 'cc_testing_question_panel_width';

    static systemTemplateConfigPanelWidth = 'cc_system_template_config_panel_width';
    static systemTemplateConfigEditorPanelWidth = 'cc_system_template_config_editor_panel_width';

    static ciramailComposerAiAssistant = 'cc_ciramail_composer_ai_assitant';
}
